<template>
  <div>
    <div class="rounded-lg w-full" style="box-shadow: 0 4px 25px 0 rgba(0,0,0,.1); "
         :style="`background-image: url(${banner})`">
      <div class="rounded-lg lg:p-12 sm:p-10 p-8">
        <div class="flex justify-between items-center" style="min-height: 150px">
          <div>
            <h5 class="font-light text-white ml-1">Classroom</h5>
            <h1 class="text-white font-bold" style="font-size: 4rem">{{ name }}</h1>
          </div>
          <!--- <img v-if="classroomData.thumbnail" :src="classroomData.thumbnail" class="rounded-lg" width="200px"
               alt=""> --->
          <div class="flex-col flex justify-center">
            <vs-button color="white" :style="`color: #${color}`" icon-pack="feather" icon="icon-edit" class="font-bold mb-1" @click="editStream">Customize</vs-button>
          </div>
        </div>
      </div>
    </div>


    <vs-popup :active.sync="editStreamPopup"  title="Edit Stream">
      <div class="popup-input" v-if="stream">
        <p class="mb-1 font-semibold">Banner</p>
        <vs-input v-model="stream.banner" class="mb-3 w-full"/>


        <p class="mb-1 font-semibold">Information <span class="font-light cursor-pointer" @click="stream.information = null">- Reset</span></p>
        <quill-editor class="mb-3" v-model="stream.information" :options="editorOption" style="min-height: 250px"/>
      </div>
    </vs-popup>

  </div>

</template>

<script>
import 'quill/dist/quill.snow.css'
import {quillEditor} from 'vue-quill-editor'

export default {
  name: 'ClassroomStreamBanner',
  data () {
    return {
      editStreamPopup: false,
      stream: null,

      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{'script': 'sub'}, {'script': 'super'}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{'align': []}],
            [{'color': []}, {'background': []}],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            ['clean']
          ]
        }
      }
    }
  },
  components: {
    quillEditor
  },
  props: {
    classroomId: {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    color: {
      type: String
    },
    banner: {
      type: String
    }
  },
  methods: {
    editStream () {
      this.$http.get(`classrooms/stream/${this.classroomId}`)
        .then(response => {
          if (response.status === 200) {
            this.stream = response.data.data
            this.editStreamPopup = true
          }
        })
    },
    updateStream () {
      this.$http.post(`classrooms/stream/${this.classroomId}`, this.stream)
        .then(response => {
          if (response.status === 200) {
            this.$emit('refresh')
            this.$vs.notify({
              title: 'Stream Updated Successfully',
              text: `${this.name} has been updated.`,
              color: 'success',
              position: 'bottom-right',
              iconPack: 'feather',
              icon: 'icon-check-circle'
            })
          }
        })
        .catch(exception => {
          this.$emit('refresh')
          let error = 'An unknown error occurred while updating this stream'
          if (exception.response) {
            error = exception.response.data.error.description
          }
          this.$vs.notify({
            title: 'Failed To Update Stream',
            text: error,
            color: 'danger',
            position: 'bottom-right',
            iconPack: 'feather',
            icon: 'icon-x-circle'
          })
        })
    }
  },
  watch: {
    editStreamPopup (val) {
      if (!val) this.updateStream()
    }
  }
}
</script>

<style scoped>
</style>
